import { postRequest } from "../config/axiosConfig";

class CustomerIndexService {
    async getChiLink(brand: string, transactionId: string) {
        return await postRequest(`${brand}/${transactionId}/getChiLink`, {transactionId});
    }
}

export default CustomerIndexService;
